webpackJsonp([10991734084388],{

/***/ 277:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(58);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(62);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _typography = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogIndex = function (_React$Component) {
	  _inherits(BlogIndex, _React$Component);
	
	  function BlogIndex() {
	    _classCallCheck(this, BlogIndex);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogIndex.prototype.render = function render() {
	    var siteTitle = (0, _get2.default)(this, 'props.data.site.siteMetadata.title');
	    var posts = (0, _get2.default)(this, 'props.data.allMarkdownRemark.edges');
	    return Glamor.createElement(
	      'div',
	      { css: {
	          maxWidth: (0, _typography.rhythm)(24),
	          margin: '0 auto'
	        } },
	      posts.map(function (_ref) {
	        var node = _ref.node;
	
	        var title = (0, _get2.default)(node, 'frontmatter.title') || node.fields.slug;
	        return Glamor.createElement(
	          'div',
	          { key: node.fields.slug },
	          Glamor.createElement(
	            'h2',
	            null,
	            title
	          ),
	          Glamor.createElement('p', { dangerouslySetInnerHTML: { __html: node.html } })
	        );
	      })
	    );
	  };
	
	  return BlogIndex;
	}(_react2.default.Component);
	
	exports.default = BlogIndex;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(18)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-index-js-baa3005df52cf4403953.js